import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_2 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"20px"} }, " 请选择您要将未出库货物转移至的新的仓库/堆场/码头 ", -1)
const _hoisted_4 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.ruleForm.Visible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
    "show-close": false,
    style: {"width":"50%"},
    "before-close": _ctx.handleClose,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "append-to-body": true
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.ruleForm.Title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_icon, {
          style: {"cursor":"pointer"},
          onClick: close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CloseBold)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3,
      _createVNode(_component_miezz_form, {
        modelValue: _ctx.formSupplier,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formSupplier) = $event)),
        ref: "ref-form-supplier",
        "label-width": "120px"
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'SupplierSource')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    onChange: _ctx.onSupplierSourceChanged,
                    modelValue: _ctx.formSupplier.Data.SupplierSource,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSupplier.Data.SupplierSource) = $event)),
                    class: "m-2",
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumSupplierSourceOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.Value,
                          label: item.Label,
                          value: item.Value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["onChange", "modelValue"])
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyTypeId')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_miezz_select, {
                    key: _ctx.supplierRandom,
                    onHandleChange: _ctx.onSupplierTypeIdChanged,
                    modelValue: _ctx.formSupplier.Data.SupplierCompanyTypeId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyTypeId) = $event)),
                    label: _ctx.formSupplier.Data.SupplierCompanyTypeLabel,
                    options: _ctx.supplierTypes
                  }, null, 8, ["onHandleChange", "modelValue", "label", "options"]))
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyId')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_select, {
                    onHandleChange: _ctx.onSupplierCompanyIdChanged,
                    modelValue: _ctx.formSupplier.Data.SupplierCompanyId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyId) = $event)),
                    label: _ctx.formSupplier.Data.SupplierCompanyLabel,
                    options: _ctx.suppliers,
                    "label-key": "NameZh",
                    "value-key": "Id"
                  }, null, 8, ["onHandleChange", "modelValue", "label", "options"])
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyContactLabel')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_input, {
                    modelValue: _ctx.formSupplier.Data.SupplierCompanyContactLabel,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyContactLabel) = $event)),
                    "fetch-suggestions": _ctx.getSupplierCompanyContact,
                    "trigger-on-focus": true,
                    clearable: "",
                    "value-key": "Label",
                    disabled: !_ctx.formSupplier.Data.SupplierCompanyId
                  }, null, 8, ["modelValue", "fetch-suggestions", "disabled"])
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'OutStockTime')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formSupplier.Data.OutStockTime,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formSupplier.Data.OutStockTime) = $event)),
                    type: "datetime",
                    style: {"width":"100% !important"},
                    placeholder: "请选择",
                    format: "YYYY/MM/DD HH:mm",
                    "default-time": _ctx.defaultTime
                  }, null, 8, ["modelValue", "default-time"])
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomButtons, (item, i) => {
          return (_openBlock(), _createBlock(_component_miezz_button, {
            style: {"width":"65px"},
            key: i,
            model: item,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["model", "onHandleClick"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}